var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66521 8.06862L11.6665 10.0774C11.8688 10.2797 11.9963 10.5646 11.9963 10.8719C11.9963 11.494 11.4941 11.9962 10.872 11.9962C10.5647 11.9962 10.2798 11.8687 10.0775 11.6664L8.06871 9.66512C7.25922 10.1823 6.29232 10.4971 5.25047 10.4971C2.34979 10.4971 0.00375366 8.15107 0.00375366 5.25038C0.00375366 2.3497 2.34979 0.00366211 5.25047 0.00366211C8.15116 0.00366211 10.4972 2.3497 10.4972 5.25038C10.4972 6.28474 10.1899 7.25163 9.66521 8.06862ZM1.50282 5.25038C1.50282 7.31909 3.18177 8.99804 5.25047 8.99804C7.31918 8.99804 8.99813 7.31909 8.99813 5.25038C8.99813 3.18168 7.31918 1.50273 5.25047 1.50273C3.18177 1.50273 1.50282 3.18168 1.50282 5.25038Z",
    fill: "#8F95B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6df3c2e0.svg";
export { ForwardRef as ReactComponent };